module.exports = __webpack_public_path__ + "img/list0.14b00573.png";